import React from 'react'
import {Bg} from '../../fm/field'
import PagedView from '../../fm/block/PagedView'

const DocumentListRenderer = (props) => {
	const {block, menu, config, screen} = props
	const view = {
		collection: 'node', 
		query: {bundle:'document', kind: block.kind},
		projection: {title: 1, path:1, date: 1},
		pageSize: 10,
		paginate: true,
		sort: undefined,
		rowRenderer: 'docRow'
	}
	
	return (
	<div id={config.id}
		className={config.classes.join(' ')}
		style={config.style}>
		{config.bg && <Bg bg={config.bg} proportional={config.classes.includes('bg-prop')} container={`#${config.id} > .block-in`} screen={screen}/>}
		{menu}
		<div className='block-in'><div className={config.contentClasses.join(' ')} style={config.contentStyle}>
			<PagedView view={view}/>
		</div></div>
	</div>
)}
export default DocumentListRenderer



// WEBPACK FOOTER //
// ./src/components/block/DocumentListRenderer.js